import FlyerFourForm from './FlyerFourForm';
import FlyerOneForm from './FlyerOneForm';
import FlyerThreeForm from './FlyerThreeForm';
import FlyerTwoForm from './FlyerTwoForm';

export default {
  FlyerFourForm,
  FlyerOneForm,
  FlyerThreeForm,
  FlyerTwoForm,
};
